module.exports = __webpack_public_path__ + "media/images/top/introduction/introduction_banner-0d6683ea7224825de30926e5526e033c.png";